import {APIService} from '@/services/api.service';
import {UserActivityCategoryEnum} from '@mobi-components/global-solution';
import debounce from 'awesome-debounce-promise';
import {POISearchOption, POISearchOptionBack} from './search-poi';
export interface POISearchResult {
  candidates: POISearchOptionBack[];
}

async function searchPoi(
  term: string,
  category: UserActivityCategoryEnum,
  context: string,
): Promise<POISearchOption[]> {
  try {
    const {candidates} = await APIService.get<POISearchResult>(
      `domain/poi/suggestions`,
      {
        params: {
          mode: process.env.VUE_APP_MODE,
          keyword: term,
          category,
          context,
        },
      },
      true,
    );
    return candidates.map((x) => ({
      ...x,
      name: x.name.replace(/_/g, ', '),
      type: x.category.toLowerCase(),
      img: x.image_url,
    }));
  } catch (e) {
    return [];
  }
}

export const deouncedPOISearch = debounce(searchPoi, 300);
